import React from 'react';

import '../../styles/components/options/editButton.scss';

export default function RemoveButton({ handleRemoveState }) {
	const removeImg = () => {
		return (
			<svg
				width='12'
				height='12'
				viewBox='0 0 12 12'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
			>
				<g clip-path='url(#clip0_810_8)'>
					<path d='M14 7H0V5H14V7Z' fill='#F63030' />
				</g>
				<defs>
					<clipPath id='clip0_810_8'>
						<rect width='12' height='12' fill='white' />
					</clipPath>
				</defs>
			</svg>
		);
	};
	return (
		<div className='remove_button_wrapper' onClick={() => handleRemoveState()}>
			<div className='remove_button_container'>{removeImg()}</div>
		</div>
	);
}
